// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingComponent_container__g-x-s","loading":"LoadingComponent_loading__3Bx5l","spin":"LoadingComponent_spin__d7TMU"};